import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import iframe from '@/pages/iframe'

// ── 路由级懒加载（2026-10-03）────────────────────────────────────────────────
// 首屏只有登录页：Login（当前路由）与 iframe（多路由共用的空壳，很小）保持同步加载；
// 其余页面全部改成动态 import —— 每个页面连同它才用得到的重型依赖
// （aplayer 只在 Index、stompjs/jquery 只在 chat）各自成 chunk，登录页不再为它们买单。
// 同一页面族的 left/main 用同一个 chunk 名，合并成一个文件、避免碎片化请求。
const Index = () => import(/* webpackChunkName: "page-index" */ '@/pages/Index')
const guideIndex = () => import(/* webpackChunkName: "page-guide-index" */ '@/pages/guideIndex')
const register = () => import(/* webpackChunkName: "page-register" */ '@/pages/register')
const homeleft = () => import(/* webpackChunkName: "page-home" */ '../components/home/homeleft.vue')
const homemain = () => import(/* webpackChunkName: "page-home" */ '../components/home/homemain.vue')
const streetleft = () => import(/* webpackChunkName: "page-street" */ '../components/street/streetleft.vue')
const streetmain = () => import(/* webpackChunkName: "page-street" */ '../components/street/streetmain.vue')
const wangdu = () => import(/* webpackChunkName: "page-wangdu" */ '../components/maps/wangdu.vue')
const about = () => import(/* webpackChunkName: "page-about" */ '../components/about/about.vue')
const version = () => import(/* webpackChunkName: "page-about" */ '../components/about/version.vue')
const property = () => import(/* webpackChunkName: "page-guide" */ '../components/guide/property.vue')
const operation = () => import(/* webpackChunkName: "page-guide" */ '../components/guide/operation.vue')
const worldmap = () => import(/* webpackChunkName: "page-guide" */ '../components/guide/worldmap.vue')
const chatMovement = () => import(/* webpackChunkName: "page-guide" */ '@/pages/chatMovement')
const verifyUserEmail = () => import(/* webpackChunkName: "page-about" */ '../components/about/verifyUserEmail.vue')
const unVerifyEmail = () => import(/* webpackChunkName: "page-about" */ '../components/about/unVerifyEmail.vue')
const initProperties = () => import(/* webpackChunkName: "page-about" */ '../components/about/initProperties.vue')
const initUserHeader = () => import(/* webpackChunkName: "page-about" */ '../components/about/initUserHeader.vue')
const sendForgetPasswordEmail = () => import(/* webpackChunkName: "page-about" */ '../components/about/sendForgetPasswordEmail.vue')
const changePasswordFromEmail = () => import(/* webpackChunkName: "page-about" */ '../components/about/changePasswordFromEmail.vue')

Vue.use(Router)

//  重写路由的push方法--->这个是vue-cli4.x以上的坑
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

const routerReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}

export default new Router({
  mode: 'history',
  //base: '/vuefantasy/', //发布要加上这一行
  routes: [
    {
      path: '/',
      name: 'login',
      hidden: true,
      meta: {
        title: '幻之大地',
        index: 0
      },
      component: Login
    }, 
    {
      path: '/main.html',
      name: '',
      meta: {
        title: '幻之大地',
        index: 1
      },
      component: Index,
      children: [
        {
          path:'/',
          meta: {
            title: '幻之大地',
            index: 2
          },
          //component:homemain,
          components: {
            default: homemain,
            left: homeleft
          }
        },
        {
          path:'/main/home.html',
          meta: {
            title: '我的家',
            index: 3
          },
          //component:homemain,
          components: {
            default: homemain,
            left: homeleft
          }
        },
        {
          path: '/main/street.html',
          meta: {
            title: '幻之大地',
            index: 4
          },
          //component: streetmain,
          components: {
            default: streetmain,
            left: streetleft
          },
          
        },
      // {
      //   path: 'street',
      //   components: {
      //     main: streetmain
      //   }
      // }
      ]
    },
    {
      path: '/map',
      name: 'map',
      component: iframe,
      children: [
        // {
        //   path:'/',
        //   components: {
        //     default: wangdu
        //   }
        // },
        {
          path:'/map/wangdu.html',
          name: 'wangdu',
          meta: {
            title: '王都维达尔加'
          },
          components: {
            default: wangdu
          }
        },
      ]
    },
    {
      path: '/about',
      component: iframe,
      children: [
        {
          path:'/about.html',
          name: 'about',
          meta: {
            title: '关于幻地'
          },
          components: {
            default: about
          }
        },
        {
          path:'/version.html',
          name: 'version',
          meta: {
            title: '版本说明'
          },
          components: {
            default: version
          }
        },
        {
          path:'/unVerifyEmail.html',
          name: 'unVerifyEmail',
          meta: {
            title: '玩家邮箱未验证'
          },
          components: {
            default: unVerifyEmail
          }
        },
        {
          path:'/verifyUserEmail.html',
          name: 'verifyUserEmail',
          meta: {
            title: '玩家邮箱验证'
          },
          components: {
            default: verifyUserEmail
          }
        },
        {
          path:'/initProperties.html',
          name: 'initProperties',
          meta: {
            title: '玩家属性初始化'
          },
          components: {
            default: initProperties
          }
        },
        {
          path:'/initUserHeader.html',
          name: 'initUserHeader',
          meta: {
            title: '玩家头像初始化'
          },
          components: {
            default: initUserHeader
          }
        },
        {
          path:'/sendForgetPasswordEmail.html',
          name: 'sendForgetPasswordEmail',
          meta: {
            title: '忘记密码'
          },
          components: {
            default: sendForgetPasswordEmail
          }
        },
        {
          path:'/changePasswordFromEmail.html',
          name: 'changePasswordFromEmail',
          meta: {
            title: '邮箱重置密码'
          },
          components: {
            default: changePasswordFromEmail
          }
        },
      ]
    },
    {
      path:'/register.html',
      name: 'register',
      component: register
    },
    {
      path:'/guideIndex.html',
      name: 'guideIndex',
      component: guideIndex
    },
    {
      path: '/guide',
      component: iframe,
      children: [
        {
          path:'/property.html',
          name: 'property',
          meta: {
            title: '旅游指南——用户属性'
          },
          components: {
            default: property
          }
        },
        {
          path:'/operation.html',
          name: 'operation',
          meta: {
            title: '旅游指南——基本操作'
          },
          components: {
            default: operation
          }
        },
        {
          path:'/worldmap.html',
          name: 'worldmap',
          meta: {
            title: '旅游指南——世界地图'
          },
          components: {
            default: worldmap
          }
        },
        {
          // 聊天动作图鉴：数据库在管理端维护，页面走 chat 服务的公开接口读 Redis，
          // 因此登录前后都可以直接访问（游戏内聊天框旁也有入口）。
          path:'/chatMovement.html',
          name: 'chatMovement',
          meta: {
            title: '旅游指南——聊天动作图鉴'
          },
          components: {
            default: chatMovement
          }
        },
      ]
    },
  ]
})
